import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../Buttons/ButtonAction';
import './Searcher.scss';
import ComboText from '../ComboText';
import { ESTADOSITEMS, ESPECIALIDADITEMS, SPECIALITIESANDSUBS } from '../../utils/ConstantsMain'
import { getSpecialityWithSub } from '../../utils/SubSpecialties'
import { useHistory, useParams } from 'react-router-dom';
import './Searcher.scss'
import { connect } from 'react-redux';
import { updatePagingLaywers } from "../../store/actions/LaywerUserAction";
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';

const useStyles = makeStyles(theme => ({
  heightSelect: {
    maxWidth: 920,
  },
  textField: {
    backgroundColor: 'white',
    margin: 0,
    padding: 0,
    height: 48,
    minWidth: '100%',
    marginRight: theme.spacing(1),
    '@media (max-width: 1250px)': {
      width: '100%',
      marginBottom: 6,
      maxWidth: 920,
    },
    '@media (max-width: 460px)': {
      minWidth: 'unset',
    },
  },
  comboText: {
    minWidth: 360,
    marginRight: theme.spacing(1),
    '@media (max-width: 1250px)': {
      width: '100%',
      marginBottom: 6,
      minWidth: 'unset'
      //maxWidth: 920,
    },
    '@media (max-width: 460px)': {
      minWidth: 'unset',
    },
  },
  select: {
    width: 360,
    marginRight: 8,
  },
  button: {
    width: 152,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1250px)': {
      width: '100%',
    },
  },
  buttonContainer: {
    width: 152,
    '@media (max-width: 1250px)': {
      width: '100%',
    },
  }
}));

const ListSearcher = (props) => {
  const { filterValues, handleBtn, role} = props;
  const classes = useStyles();
  const history = useHistory();
  const { specialty, subSpeciality } = useParams()
  const [inputSp, setInputSp] = useState('');
  const [inputSt, setInputSt] = useState('');
  const [spChanged, setSpChanged]  = useState(false);
  const [stChanged, setStChanged]  = useState(false);
  const [specialityState, setSpecialityState] = useState('')
  const [subSpecialityState, setSubSpecialityState] = useState('')
  const [didRender, setDidRender] = useState(false)

  useEffect(() => {
    if (!didRender) {
      if(!spChanged){
        setInputSp(filterValues.specialtySelected);
      }
      if(!stChanged){
        setInputSt(filterValues.stateSelected);
      }
      if (specialty && subSpeciality) {
        setSpecialityState(specialty)
        setSubSpecialityState(subSpeciality)
        setInputSp(subSpeciality);
      } else if (specialty) {
        setSpecialityState(specialty)
        setInputSp(specialty);
      } else {
        setSpecialityState('')
        setInputSp('');
      }
      setDidRender(true)
    }
  }, [didRender, filterValues.specialtySelected, filterValues.stateSelected, spChanged, specialty, stChanged, subSpeciality, subSpecialityState]);

  const handleSetSpecialty = field => value => {
    setSpChanged(true)
    if (ESPECIALIDADITEMS.includes(value)) {
      setInputSp(value)
      setSpecialityState(value)
      setSubSpecialityState('')
    } else if (SPECIALITIESANDSUBS.includes(value)) {
      const spe = getSpecialityWithSub(value)
      setInputSp(value)
      setSpecialityState(spe)
      setSubSpecialityState(value)
    } else {
      setInputSp('')
      setSpecialityState('')
      setSubSpecialityState('')
    }
    history.replace(`/busqueda`)
  };

  const handleSetState = field => value => {
    setStChanged(true)
    setInputSt(value)
    history.replace(`/busqueda`)
  };

  const handlerButtonSearch = () => {
    props.showLoading();
    handleBtn(inputSt, specialityState, subSpecialityState)
    props.updatePagingLaywers(
      role == 1 ? 'lawFirm' : 'lawyer',
      1,
      specialityState,
      subSpecialityState,
      inputSt
    )
    .then(res => {
      props.hideLoading();
    })
  }
  
  return (
    <div>
      <div className="Listsearcher">
        <div className={classes.comboText}>
          <ComboText
            labelText={'Especialidad / Asuntos legales'}
            typeSelect={inputSp}
            itemsCombo={SPECIALITIESANDSUBS}
            handleChanges={handleSetSpecialty('specialties')}
            name={'specialties'}
            inSearcher
          />
        </div>
        <div className={classes.comboText}>
          <ComboText
            labelText={'Estado'}
            itemsCombo={ESTADOSITEMS}
            handleChanges={handleSetState('states')}
            name={'states'}
            typeSelect={inputSt}
            inSearcher
          />
        </div>
        <div className={classes.buttonContainer} onClick={handlerButtonSearch}>
          
            <Button
              variant="extra"
              className={classes.button}
            >
              <img
                src="/img/LandingClient/search.svg"
                alt="buscar"
                style={{ marginRight: 16 }}
              />
              Buscar
            </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) =>({
  laywerData: state.paginationReducer.laywerData
});

const mapDispatchToProps = dispatch => ({
  updatePagingLaywers: (role, page, specialty, subSpecialty, state) =>
    dispatch(updatePagingLaywers(role, page, specialty, subSpecialty, state)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
}); 

export default connect(mapStateToProps, mapDispatchToProps)(ListSearcher);